if (!customElements.get('manis-fastrr-checkout')) {
  customElements.define('manis-fastrr-checkout', class extends HTMLElement {
    connectedCallback() {
      this.checkoutSlot = this.querySelector('.shiprocket-headless');
      this.fallback = this.querySelector('[data-manis-checkout-fallback]');
      this.scope = this.closest('product-info') || this;
      this.sync = this.sync.bind(this);
      this.guard = (event) => {
        if (this.checkoutSlot.contains(event.target) && this.isBlocked()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      this.addEventListener('click', this.guard, true);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.scope, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'value'],
      });
      this.scope.addEventListener('change', this.sync);
      this.sync();
    }

    isBlocked() {
      const form = this.closest('product-form');
      const control = this.dataset.mode === 'product'
        ? form?.querySelector('[name="add"]')
        : this.fallback.querySelector('[name="checkout"]');
      // Keep the native checkout for selling plans and custom line properties.
      // Their semantics must not be lost in a third-party product checkout.
      const hasCustomPurchase = form && Array.from(form.querySelectorAll('[name]')).some((input) =>
        (input.name === 'selling_plan' || input.name.startsWith('properties[')) && input.value
      );
      return !control || control.disabled || control.getAttribute('aria-disabled') === 'true' || Boolean(hasCustomPurchase);
    }

    sync() {
      if (!this.checkoutSlot || !this.fallback) return;
      const action = this.dataset.mode === 'product' ? 'buyProduct' : 'buyCart';
      const ready = typeof window.shiprocketCheckoutEvents?.[action] === 'function'
        && this.checkoutSlot.querySelector('button') && !this.isBlocked();
      this.checkoutSlot.hidden = !ready;
      this.fallback.hidden = Boolean(ready);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.scope?.removeEventListener('change', this.sync);
      this.removeEventListener('click', this.guard, true);
    }
  });
}
